/* global axios */
import ApiClient from '../ApiClient';

class FinancialAttachmentsAPI extends ApiClient {
  constructor() {
    super('financeiro/obligations', { accountScoped: true });
  }

  getAll(obligationId) {
    return axios.get(`${this.url}/${obligationId}/attachments`);
  }

  upload(obligationId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${obligationId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  delete(obligationId, attachmentId) {
    return axios.delete(
      `${this.url}/${obligationId}/attachments/${attachmentId}`
    );
  }
}

export default new FinancialAttachmentsAPI();
